<template>
  <v-col>
    <!-- sales data table -->
    <custom-product-table
      :key="index"
      url-api="/custom-product"
      :headers="headers"
    >
      <!-- New Product -->
      <template v-slot:urlCreate="{ item }">
        <v-btn
          class="info"
          @click.prevent="
            $router.push({
              name: 'CustomProductForm',
            })
          "
        >
          <v-icon>mdi-plus</v-icon>
          Buy From Customer
        </v-btn>
      </template>

      <!-- end -->

      <!-- Product logo uploading -->
      <template v-slot:image="{ item }">
        <v-edit-dialog>
          <v-img
            :src="'/storage/' + item.image"
            lazy-src="/storage/default_img/no_image.png"
            aspect-ratio="1"
            max-width="30"
            max-height="30"
          />
          <template v-slot:input>
            <v-file-input
              v-model="product.image"
              label="Select File"
              placeholder="Upload Image"
              accept="image/jpg, image/png, image/jpeg"
              @change="uploadItemImage(item)"
            />
          </template>
        </v-edit-dialog>
      </template>
      <!-- end -->

      <!-- ColumnActions -->
      <template v-slot:columnaction="{ item }">
        <!-- Product edit -->
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              small
              v-on="on"
              @click.prevent="
                $router.push({
                  name: 'CustomProductForm',
                  params: { id: item.id },
                })
              "
            >
              <v-icon>
                mdi-pencil
              </v-icon>
            </v-btn>
          </template>
          <span>Product Edit</span>
        </v-tooltip>
        <!-- end -->

        <!-- Product  Purchase print -->
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              small
              v-on="on"
              @click.prevent="
                $router.push({
                  name: 'CustomBuyPrint',
                  params: { id: item.id },
                })
              "
            >
              <v-icon>
                mdi-printer
              </v-icon>
            </v-btn>
          </template>
          <span>Print</span>
        </v-tooltip>
        <!-- end -->
        <!-- Product  Purchase Invoice -->
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              small
              v-on="on"
              @click.prevent="pdfInvoice(item.id)"
            >
              <v-icon class="error--text">
                mdi-file-pdf
              </v-icon>
            </v-btn>
          </template>
          <span>Download PDF</span>
        </v-tooltip>
        <!-- end -->

        <!-- Product details -->
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              small
              v-on="on"
              @click.prevent="
                $router.push({
                  name: 'CustomProductDetails',
                  params: { id: item.id },
                })
              "
            >
              <v-icon>
                mdi-more
              </v-icon>
            </v-btn>
          </template>
          <span>Custom Product Details</span>
        </v-tooltip>
        <!-- end -->

        <!-- Product remove -->
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              small
              icon
              @click="warningProductRemove(item)"
              v-on="on"
            >
              <v-icon>
                mdi-delete
              </v-icon>
            </v-btn>
          </template>
          <span>Delete</span>
        </v-tooltip>
        <!-- end -->
      </template>
      <!-- end columnActions -->
    </custom-product-table>

    <!-- end data table -->

    <!-- Product remove warning -->
    <v-dialog
      v-model="productRemoveWarning"
      persistent
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">
          Warning
        </v-card-title>
        <v-card-text>
          Are you sure to remove ?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="green darken-1"
            text
            @click="productRemoveWarning = false"
          >
            Cancel
          </v-btn>
          <v-btn
            color="red darken-1"
            text
            @click="removeProduct"
          >
            Remove
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end -->
  </v-col>
</template>

<script>
import CustomProductTable from "../common/DataTable.vue";
import { mapActions } from "vuex";

export default {
  components: {
    "custom-product-table": CustomProductTable,
  },
  data() {
    return {
      product: {},
      productRemoveWarning: false,
      refund: [],
      index: 1,
      toggleStates: [
        { title: "Yes", value: 1 },
        { title: "No", value: 0 },
      ],
      headers: [
        {
          text: "Date",
          sortable: true,
          value: "created_at",
        },

        {
          text: "Image",
          sortable: true,
          value: "image",
          slot: "image",
        },
        {
          text: "Customer Name",
          sortable: true,
          value: "fullName",
        },
        {
          text: "Phone",
          sortable: false,
          value: "phone",
        },
        {
          text: "Device Model",
          sortable: false,
          value: "model",
        },
        {
          text: "Imei",
          sortable: false,
          value: "imei",
        },
        {
          text: "Cost",
          sortable: true,
          value: "cost",
        },
        {
          text: "Price",
          sortable: true,
          value: "price",
        },

        {
          text: "Actions",
          sortable: false,
          slot: "columnaction",
        },
      ],
    };
  },

  methods: {
    ...mapActions({
      feedback: "snackbar/show",
    }),
    pdfInvoice(invoice) {
      window
        .axios({
          method: "GET",
          responseType: "blob",
          url: `/export-custom-buy-invoice/${invoice}`,
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data])),
            link = document.createElement("a");

          link.href = url;
          link.setAttribute("download", `exported.pdf`);
          document.body.appendChild(link);
          link.click();
        });
    },
    uploadItemImage(item) {
      if (this.product.image !== null) {
        let formData = new FormData();
        formData.append("image", this.product.image, this.product.image.name);
        window.axios
          .post(`/custom-product-image/${item.id}`, formData)
          .then((response) => {
            this.product.image = null;
            this.feedback(response.data.message);
            this.$data.index++;
          });
      }
    },

    removeProduct() {
      window.axios
        .delete("/custom-product/" + this.$data.product.id)
        .then((response) => {
          this.feedback(response.data.message);
          this.productRemoveWarning = false;
          this.$data.index++;
        });
    },

    warningProductRemove(product) {
      this.product = product;
      this.productRemoveWarning = true;
    },
  },
};
</script>
